// api.js
export const sendBookingMessage = async (payload) => {
    try {
      const response = await fetch("https://xae0-ycmh-cnpt.n7c.xano.io/api:cyRcmRX9/vendors/book_vendor", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(payload),
      });
      return response;
    } catch (error) {
      console.error("Error sending message:", error);
      throw error;
    }
  };
  